import { makeStyles } from "tss-react/mui"
import { Box, Typography } from "@mui/material"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCircleInfo } from "@fortawesome/pro-regular-svg-icons"

const useStyles = makeStyles()((theme) => ({
    infoWrap: {
        display: "grid",
        alignItems: "flex-start",
        gridTemplateColumns: "1rem 1fr",
        background: theme.palette.tailwind.sky[50],
        borderRadius: "0.5rem",
        gap: "0.625rem",
        padding: "0.75rem",
        color: theme.palette.tailwind.sky[700],
        width: "100%",
        "&> svg": {
            display: "block",
        },
    },
}))

type InfoBoxProps = { description: string | JSX.Element }

export const InfoBox = ({ description }: InfoBoxProps) => {
    const { classes } = useStyles()

    return (
        <Box className={classes.infoWrap}>
            <FontAwesomeIcon icon={faCircleInfo} />
            <Typography variant="body2">{description}</Typography>
        </Box>
    )
}
